import React, { useState } from "react";
import { ActivityIndicator, Dimensions, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StepperTypeTokens, } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Button } from "../../button/Button";
import { Image } from "../../image/Image";
import { isMobile } from "../../stack/utils";
import { Typography } from "../../typography/Typography";
import WebView from "react-native-webview";
import { Header } from "../../header/Header";
import LottieView from "lottie-react-native";
import ThemeProvider from "@voltmoney/theme";
import BottomSheetMf from "../../bottomSheetMF/bottomSheetMf";
import Stack from "../../stack/Stack";
import Space from "../../space/Space";
import Icon from "../../icon/Icon";
import NeedHelpDC from "../NeedHelpDC";
const DspKfsPage = ({ stepperProps, height, lenderInfo, isJupiter, contactUsAction, loading, backAction, triggerAction, successAction, failureAction, navNextAction, showSuccessModal, showFailureModal, onModalCloseAction, counter, url, showWaitingForResponse, contactUsDetails }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [_lenderInfo, setLenderInfo] = useState(lenderInfo);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const webViewRef = React.useRef(null);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const stepperDetails = {
        data: stepperProps,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    const openContactUs = () => {
        contactUsAction &&
            triggerAction(contactUsAction);
    };
    const onLoadEnd = () => {
        setIsLoaded(true);
    };
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const successModalContent = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: Platform.OS === 'ios' ? 25 : 0
            } },
            Platform.OS !== 'web' ?
                React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: styles.successLottie, autoPlay: true, loop: true }) :
                React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusSuccess_1.svg', width: 48, height: 48 }),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(Typography, { label: 'Agreement signed successfully!', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 }),
            React.createElement(View, { style: { height: 4 } }),
            React.createElement(Typography, { label: ' You will be redirected to next step in few seconds', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, numberOfLines: 2 }),
            React.createElement(View, { style: { height: 24 } }),
            React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, label: 'Proceed to next step', fontFamily: FontFamilyTokens.Inter, onPress: () => {
                    navNextAction &&
                        triggerAction(navNextAction);
                } })));
    };
    const failureModalContent = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            } },
            React.createElement(Image, { size: ImageSizeTokens.Size_40, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StatusFailed_1.svg', width: 48, height: 48 }),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(Typography, { label: 'Agreement signing failed!', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 }),
            React.createElement(View, { style: { height: 4 } }),
            React.createElement(Text, { style: {
                    fontFamily: 'Inter',
                    fontSize: 14,
                    fontWeight: '400',
                    lineHeight: 20,
                    textAlign: 'center',
                    color: '#667085',
                } }, isMobile(getScreenType(Dimensions.get('window').width)) ? "We encountered an error while signing the loan agreement. Please retry the process." : "We encountered an error while signing the loan agreement.\nPlease retry the process."),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 16
                } },
                React.createElement(Text, { style: {
                        fontFamily: 'Inter',
                        fontSize: 14,
                        fontWeight: '400',
                        lineHeight: 24,
                        color: '#1D2939'
                    } }, "Need help?"),
                React.createElement(View, { style: { width: 5 } }),
                React.createElement(TouchableOpacity, { onPress: () => {
                        openContactUs();
                    } },
                    React.createElement(Typography, { label: "Contact us", fontSize: FontSizeTokens.SM, lineHeight: 24, fontWeight: "600", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Primary_100 })))));
    };
    const InProgressCard = () => {
        return (React.createElement(View, { style: [
                {
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    borderRadius: 12,
                    padding: 16,
                },
            ] },
            React.createElement(Stack, { justifyContent: StackJustifyContent.center, alignItems: StackAlignItems.center },
                React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
                React.createElement(Icon, { name: IconTokens.Redirecting, size: IconSizeTokens.Size56 }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Text, { style: {
                        textAlignVertical: 'center',
                        textAlign: 'center',
                    } },
                    React.createElement(Typography, { label: "Waiting for response", color: ColorTokens.Grey_Night, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.XL, numberOfLines: 2 })),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(View, { style: {
                        justifyContent: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(Text, { style: {
                            textAlignVertical: 'center',
                            textAlign: 'center',
                        } },
                        React.createElement(Typography, { label: "Please wait while we process your request", color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, numberOfLines: 2 }))),
                React.createElement(Space, { size: SizeTypeTokens.XXXL }))));
    };
    const handleAgreementCompleted = async () => {
        successAction &&
            await triggerAction(successAction);
        // setShowSuccessModal(true)
    };
    const handleAgreementFailure = async () => {
        failureAction &&
            await triggerAction(failureAction);
        // setShowFailureModal(true)
    };
    const onMessage = async (event) => {
        console.log("Event: ", event);
        if (event?.nativeEvent?.data) {
            let eventData;
            try {
                // Parse only if it's a string
                eventData = typeof event.nativeEvent.data === "string"
                    ? JSON.parse(event.nativeEvent.data)
                    : event.nativeEvent.data;
            }
            catch (error) {
                console.error("Failed to parse event data:", error);
                return; // Exit function if parsing fails
            }
            if (eventData?.success === true || eventData?.success === "true") {
                await handleAgreementCompleted();
                console.log("------- Agreement success case -------");
            }
            else if (eventData?.success === false || eventData?.success === "false") {
                await handleAgreementFailure();
            }
        }
    };
    const renderLoader = () => (React.createElement(View, { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: Platform.OS === 'ios' ? height - 130 : height - 109
        } },
        React.createElement(ActivityIndicator, { size: 'large', color: colorMapping[ColorTokens.Primary_100] })));
    const renderWebView = () => (React.createElement(React.Fragment, null,
        url && !isLoaded && (renderLoader()),
        url && (React.createElement(WebView, { source: {
                uri: url
            }, containerStyle: Platform.OS === 'ios' ? {
                position: 'relative',
                top: 8
            } : {}, style: !isLoaded ? {
                height: 0
            } : {
                height: Platform.OS === 'ios'
                    ? height - 162
                    : Platform.OS === 'android' ? height - 125 : height - 119,
            }, scalesPageToFit: true, originWhitelist: ['*'], useWebKit: true, ref: webViewRef, onMessage: onMessage, javaScriptEnabled: true, javaScriptEnabledAndroid: true, javaScriptCanOpenWindowsAutomatically: true, allowFileAccess: true, domStorageEnabled: true, mixedContentMode: 'always', mediaPlaybackRequiresUserAction: false, allowsInlineMediaPlayback: true, onLoad: onLoadEnd }))));
    const renderKFS = () => {
        return (React.createElement(React.Fragment, null, loading ?
            renderLoader()
            : renderWebView()));
    };
    const _bodyChild = () => {
        return (React.createElement(ScrollView, { style: {
                height: height - 210,
            } },
            React.createElement(React.Fragment, null, renderKFS())));
    };
    const renderModal = () => {
        return showWaitingForResponse
            ? InProgressCard()
            : showSuccessModal
                ? successModalContent()
                : showFailureModal
                    ? failureModalContent()
                    : React.createElement(React.Fragment, null);
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.headerStyle },
                React.createElement(Header, { id: "bt_reviewAgreement_goBack", type: HeaderTypeTokens.verification, stepperProps: stepperDetails, isBackButton: true, needHelpIcon: true, isFromJupiter: isJupiter, needHelpAction: handleNeedHelp, title: "Review Agreement", height: Platform.OS !== 'ios'
                        ? '100%'
                        : undefined, onPress: () => {
                        if (backAction) {
                            triggerAction(backAction);
                        }
                    } })),
            React.createElement(View, { style: [
                    styles.body,
                    {
                        height: height - 108,
                        position: 'relative',
                        top: Platform.OS === 'ios' ? 30 : 0
                    }
                ] }, _bodyChild()),
            React.createElement(BottomSheetMf, { modalVisible: showWaitingForResponse ||
                    showSuccessModal ||
                    showFailureModal, showClose: showWaitingForResponse ? false : true, onModalClose: () => {
                    onModalCloseAction &&
                        triggerAction(onModalCloseAction);
                } }, renderModal())),
        showNeedHelp &&
            React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isJupiter })));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 50
    },
    successLottie: { width: 70, height: 70 },
    body: {
    // paddingHorizontal: 16,
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: '#FFF',
        padding: 16,
        marginTop: 16,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionLeftCardContainer: {
        flex: 3,
        display: 'flex',
        flexDirection: 'row',
    },
    transactionRightCardContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    webview: {
        flex: 1,
    },
    headerStyle: { width: '100%', flex: 1, ...Platform.OS === "ios" && {
            marginTop: 24
        } },
    modalContainer: {
        alignItems: "center",
        padding: 16,
        flex: 1
    },
});
export default DspKfsPage;
